import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-013c0f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","z-index":"1","height":"100%","width":"100%","left":"0","top":"0"}
}
const _hoisted_2 = { class: "modal is-active" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h2 class=\"title\" data-v-013c0f80>How it works</h2><div class=\"content is-normal\" data-v-013c0f80><ul data-v-013c0f80><li data-v-013c0f80> MoonHeads ZooMers are now <strong data-v-013c0f80>backed by a growing pool of rETH</strong> stored in a <a target=\"_blank\" href=\"https://etherscan.io/address/0x0ed8385365adffc23350e92423c3844b07761087\" data-v-013c0f80>smart contract</a>. rETH&#39;s price naturally appreciates at ~5% year compared to ETH. <a href=\"https://rocketpool.net/\" target=\"_blank\" data-v-013c0f80>Learn more about rETH</a>. </li><li data-v-013c0f80>100% of collection royalties from MoonHeads will be converted to rETH and added back to the pool.</li><li data-v-013c0f80> To claim your rETH and <strong style=\"color:red;\" data-v-013c0f80>burn your NFTs</strong>, use the burn function below. <strong data-v-013c0f80>10% of the claim amount is taxed and added back to the pool</strong>. </li><li data-v-013c0f80> The claim amount per NFT is determined by the following calculation:<br data-v-013c0f80><i data-v-013c0f80>(rETH in contract) / (5000 - NFTs Burned) * 0.9</i></li><li data-v-013c0f80>There will be more ways the rETH pool size will increase in the future, such as reminting burned NFTs at a high premium.</li></ul></div>", 2)
const _hoisted_7 = {
  class: "content",
  style: {"color":"#EC7050","font-weight":"bold"}
}
const _hoisted_8 = { class: "message is-warning" }
const _hoisted_9 = { class: "message-body" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Enter the IDs of the NFTs that you want to burn, separated by commas. Get your IDs ")
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". The ID is the number next to your NFT. ")
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = {
  key: 0,
  class: "button is-large is-static"
}
const _hoisted_16 = {
  key: 2,
  class: "button is-large is-static"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "ZooMers are Up Only!", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
    /*#__PURE__*/_createTextVNode("MoonHeads ZooMers are now backed by a growing pool of "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://rocketpool.net/"
    }, "rETH tokens"),
    /*#__PURE__*/_createTextVNode(", with auto compounding rewards!")
  ])
], -1))
const _hoisted_19 = {
  key: 1,
  class: "buttons is-centered"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://pro.opensea.io/collection/moonheads-zoomers",
  target: "_blank",
  class: "button is-large is-success"
}, "Buy", -1))
const _hoisted_21 = {
  key: 2,
  class: "section has-text-centered"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"display":"inline-block","font-size":"5rem"},
  class: "loader is-loading"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "subtitle" }
const _hoisted_26 = { class: "buttons is-centered" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://pro.opensea.io/collection/moonheads-zoomers",
  target: "_blank",
  class: "button is-large is-success"
}, "Buy", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.burnModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.burnModal = !_ctx.burnModal)),
              class: "modal-background"
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("p", _hoisted_7, "You currently hold " + _toDisplayString(_ctx.totalHeld) + " ZooMers redeemable for " + _toDisplayString(_ctx.redeemValue * _ctx.totalHeld) + " rETH (" + _toDisplayString(_ctx.redeemValue * _ctx.totalHeld * _ctx.ethValue) + " ETH)", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("a", {
                      target: "_blank",
                      href: 'https://opensea.io/' + _ctx.$store.state.connectedAddress + '?search[collections][0]=moonheads-zoomers'
                    }, "here", 8, _hoisted_11),
                    _hoisted_12
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "1,2,3",
                    class: "input is-warning",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.burnIds) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.burnIds]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.burnStatus === 'APPROVING')
                    ? (_openBlock(), _createElementBlock("button", _hoisted_15, "Approving..."))
                    : (_ctx.cleanBurnIds.length > 1 && !_ctx.isRethPoolApproved)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.approveRethPool && _ctx.approveRethPool(...args))),
                          class: "button is-large is-reth-orange"
                        }, "Approve"))
                      : (_ctx.burnStatus === 'BURNING')
                        ? (_openBlock(), _createElementBlock("button", _hoisted_16, "Burning..."))
                        : (_ctx.burnStatus === 'WAITING')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.burn && _ctx.burn(...args))),
                              class: _normalizeClass([{ 'is-static': _ctx.cleanBurnIds.length === 0 }, "button is-large is-reth-orange"])
                            }, " Burn for " + _toDisplayString(_ctx.redeemValue * _ctx.cleanBurnIds.length) + " rETH ", 3))
                          : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.burnModal = !_ctx.burnModal)),
              class: "modal-close is-large",
              "aria-label": "close"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_17,
    _hoisted_18,
    (!_ctx.$store.state.connectedAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.init && _ctx.init(...args))),
            class: "button is-large is-reth-orange"
          }, "Connect"),
          _hoisted_20
        ]))
      : (!_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, "Redeem 1 ZooMer for " + _toDisplayString(_ctx.redeemValue.toFixed(4)) + " rETH (" + _toDisplayString((_ctx.redeemValue * _ctx.ethValue).toFixed(4)) + " ETH)", 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "button is-large is-reth-orange",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.burnModal = !_ctx.burnModal))
              }, "Open Burner"),
              _hoisted_27
            ])
          ]))
  ], 64))
}